export default [
  { label: 'Aviation', value: 'Aviation' },
  { label: 'Ground', value: 'Ground' }
]
